<script setup>
// Google Ads > Raporlar
//
// Iki kirilim: gune gore ve cihaza gore. Grafik kutuphanesi eklemiyoruz;
// gunluk harcama basit bir cubuk seridiyle gosteriliyor. Tek bir sayiya
// bakmaktansa egilimi gormek yeterli, bunun icin de ek bir bagimlilik
// tasimaya gerek yok.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni, para } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const gunluk = ref([]);
const cihaz = ref([]);
const paraBirimi = ref('');
const yukleniyor = ref(false);
const hata = ref('');

const GUN_SUTUN = [
  { alan: 'tarih', anahtar: 'GOOGLE_ADS.SUTUN.TARIH', vurgu: true, siralanabilir: true },
  { alan: 'harcama', anahtar: 'GOOGLE_ADS.SUTUN.HARCAMA', tur: 'para', siralanabilir: true },
  { alan: 'gosterim', anahtar: 'GOOGLE_ADS.SUTUN.GOSTERIM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA', tur: 'sayi', siralanabilir: true },
  { alan: 'donusum', anahtar: 'GOOGLE_ADS.SUTUN.DONUSUM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama_orani', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA_ORANI', tur: 'yuzde' },
];

const CIHAZ_SUTUN = [
  { alan: 'cihaz', anahtar: 'GOOGLE_ADS.SUTUN.CIHAZ', tur: 'etiket', vurgu: true },
  { alan: 'harcama', anahtar: 'GOOGLE_ADS.SUTUN.HARCAMA', tur: 'para', siralanabilir: true },
  { alan: 'gosterim', anahtar: 'GOOGLE_ADS.SUTUN.GOSTERIM', tur: 'sayi', siralanabilir: true },
  { alan: 'tiklama', anahtar: 'GOOGLE_ADS.SUTUN.TIKLAMA', tur: 'sayi', siralanabilir: true },
  { alan: 'donusum', anahtar: 'GOOGLE_ADS.SUTUN.DONUSUM', tur: 'sayi', siralanabilir: true },
];

const enYuksek = computed(() =>
  gunluk.value.reduce((u, g) => Math.max(u, g.harcama || 0), 0)
);

// Cubuk yuksekligi orantili; en yuksek gun %100. Hepsi sifirsa cubuk yok.
const yukseklik = harcama => {
  if (!enYuksek.value) return 0;
  return Math.max(2, Math.round(((harcama || 0) / enYuksek.value) * 100));
};

const kisaTarih = tarih => String(tarih || '').slice(5);

const yukle = async aralik => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'raporlar', { aralik });
    gunluk.value = veri.gunluk || [];
    cihaz.value = veri.cihaz || [];
    paraBirimi.value = veri.para_birimi || '';
  } catch (e) {
    gunluk.value = [];
    cihaz.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk :baslik="t('GOOGLE_ADS.RAPORLAR')" @aralik="yukle">
    <div class="flex flex-col gap-5">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>

      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>

      <template v-else>
        <section
          v-if="gunluk.length"
          class="flex flex-col gap-3 p-4 border rounded-xl border-n-weak"
        >
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('GOOGLE_ADS.GUNLUK_HARCAMA') }}
          </h2>
          <div class="flex items-end gap-1 h-32">
            <div
              v-for="g in gunluk"
              :key="g.tarih"
              class="flex flex-col justify-end flex-1 h-full min-w-0 group"
              :title="`${g.tarih} · ${para(g.harcama, paraBirimi)}`"
            >
              <div
                class="w-full rounded-t bg-n-brand/60 group-hover:bg-n-brand transition-colors"
                :style="{ height: `${yukseklik(g.harcama)}%` }"
              />
            </div>
          </div>
          <div class="flex justify-between text-xs text-n-slate-11">
            <span>{{ kisaTarih(gunluk[0]?.tarih) }}</span>
            <span>{{ kisaTarih(gunluk[gunluk.length - 1]?.tarih) }}</span>
          </div>
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('GOOGLE_ADS.CIHAZ_KIRILIMI') }}
          </h2>
          <GoogleAdsTablo
            :sutunlar="CIHAZ_SUTUN"
            :satirlar="cihaz"
            :para-birimi="paraBirimi"
            varsayilan-siralama="harcama"
          />
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('GOOGLE_ADS.GUN_GUN') }}
          </h2>
          <GoogleAdsTablo
            :sutunlar="GUN_SUTUN"
            :satirlar="gunluk"
            :para-birimi="paraBirimi"
          />
        </section>
      </template>
    </div>
  </GoogleAdsKabuk>
</template>
